import { combineReducers } from "redux";
import { SeoSetting } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_SEO_SETTING_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<SeoSetting> = {}, action: Action): Partial<SeoSetting> {
  switch (action.type) {
    case getSuccessActionType(FETCH_SEO_SETTING_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_SEO_SETTING_REQUEST:
      return true;
    case getSuccessActionType(FETCH_SEO_SETTING_REQUEST):
    case getFailureActionType(FETCH_SEO_SETTING_REQUEST):
      return false;

    default:
      return state;
  }
}

export const seoSetting = combineReducers({ item, isFetching });
